<div class="bonusItem__text">
  <h2>
    <span class='decorator'><i aria-hidden='true' class='fa fa-diamond'></i></span>
    <span class='textHeader'>{{ item.title }}</span>
  </h2>
  <div [innerHtml]="item.text"></div>
</div>
